import * as React from "react";
import ChevronPanel from "../../../Shared/ChevronPanel/ChevronPanel";
import {
    GetLinkSuggestions,
    GetParentLinkId,
    SelectParentLink,
} from "../DreamEditor/ParentLink/ParentLink";
import { FilterByDifficulty } from "source/app/presentation/MainPanel/Dreams/Filter/Difficulty/FilterByDifficulty";
import { FilterByEmotion } from "source/app/presentation/MainPanel/Dreams/Filter/Emotion/FilterByEmotion";
import { FilterByAttribute } from "source/app/presentation/MainPanel/Dreams/Filter/FilterByAttribute";
import * as styles from "../Dreams.css";
import { IDreamsState } from "../IDreamsState";
import { DreamToolsIcon } from "./DreamToolsIcon/DreamToolsLabel";
import { IDreamToolsOptions } from "./IDreamToolsOptions";
import { Switch } from "./Switch/Switch";

export function DreamTools({ state, setState }: IDreamToolsOptions) {
    const dreamToolsIcon = <DreamToolsIcon state={state} setState={setState} />;

    return (
        <ChevronPanel id="dreamTools" label={dreamToolsIcon}>
            <FilterByDifficulty
                styles={styles}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                    setState({
                        selectedDifficulty: parseInt(event.target.value),
                    })
                }
                selectedDifficulty={state.selectedDifficulty}
            />
            <FilterByEmotion
                style={styles.emotionSelector}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                    setState({ selectedEmotion: event.target.value })
                }
                selectedAttribute={state.selectedEmotion}
            />
            <FilterByAttribute
                style={styles.attributeSelector}
                onChange={(event: React.ChangeEvent<HTMLSelectElement>) =>
                    setState({
                        selectedAttributes: event.target.value
                            ? [event.target.value]
                            : [],
                    })
                }
                selectedAttribute={state.selectedAttributes[0] ?? ""}
            />
            <Switch
                label="Campaigns"
                isChecked={state.onlyShowMasterDreams}
                onChange={(value) => setState({ onlyShowMasterDreams: value })}
            />
            <SelectParentLink
                suggestions={GetLinkSuggestions(state.dreamsdata)}
                onChange={(dreamName) => {
                    const selectedCampaignId =
                        GetParentLinkId(state.dreamsdata, dreamName) ?? 0;

                    setState({ selectedCampaignId });
                }}
                selectedLinkName={GetDreamName(state)}
            />
        </ChevronPanel>
    );
}

function GetDreamName(state: IDreamsState) {
    if (!state.dreamsdata) {
        return "";
    }

    const dream = state.dreamsdata.find(
        (dream) => dream.id === state.selectedCampaignId
    );

    if (!dream) {
        return "";
    }

    return dream.name;
}
